import React from "react";
import Image from "next/image";
import DefaultCurrencyFormat from "../calendar/DefaultCurrencyFormat";
import { useDetailContext } from "@/context/detailContext";

const OpportunityDateCard = ({ item }) => {
  const { selectedDatesFilter, setSelectedDatesFilter } =
    useDetailContext() || {};
  const splitDate1 = item.gun1.split(" ");
  const splitDate2 = item.gun2.split(" ");
  const tarih1 = item.tarih1; // format "22.07.2025" to YYYY-MM-DD
  const tarih2 = item.tarih2; // "23.07.2025" format to YYYY-MM-DD
  const tarih1Date = tarih1.split(".").reverse().join("-");
  const tarih2Date = tarih2.split(".").reverse().join("-");

  return (
    <div className="flex flex-col items-start xl:p-6 p-4 lg:gap-4 gap-2 bg-[#303C42] rounded-xl">
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center gap-4">
          <div className="flex flex-col items-center justify-center w-[54px] h-[54px] flex-shrink-0 rounded-[10px] bg-[#F0F4F9]">
            <span className="text-themeBlack text-2xl font-bold">
              {splitDate1[0]}
            </span>
            <span className="text-themeBlack text-size-10 font-bold">
              {splitDate1[1]}
            </span>
          </div>
          <Image
            src="/icons/left-and-right-arrowsxxxx.svg"
            width={17}
            height={17}
            alt="Left and Right Arrows"
            className="object-contain"
          />
          <div className="flex flex-col items-center justify-center w-[54px] h-[54px] flex-shrink-0 rounded-[10px] bg-[#F0F4F9]">
            <span className="text-themeBlack text-2xl font-bold">
              {splitDate2[0]}
            </span>
            <span className="text-themeBlack text-size-10 font-bold">
              {splitDate2[1]}
            </span>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Image
            src="/icons/ay.svg"
            width={20}
            height={20}
            alt="ay"
            className="object-contain"
          />
          <span className="text-white text-base font-medium leading-4">
            {item?.gece} Gece
          </span>
        </div>
      </div>
      <div className="flex items-center justify-between w-full">
        <span className="text-white text-base font-medium leading-4">
          Kısa süreli indirimli
        </span>
        <div className="flex flex-col items-start">
          <span className="text-[#9CA5B0] text-size-13 font-bold line-through">
            <DefaultCurrencyFormat
              value={parseFloat(item?.fiyat) + parseFloat(item?.IndirimTutari)}
              Symbol={item?.Symbol}
            />
          </span>
          <span className="text-white text-xl font-bold">
            <DefaultCurrencyFormat
              value={parseFloat(item?.fiyat)}
              Symbol={item?.Symbol}
            ></DefaultCurrencyFormat>
          </span>
        </div>
      </div>
      <button
        type="button"
        onClick={() =>
          setSelectedDatesFilter([
            {
              startDate: new Date(tarih1Date),
              endDate: new Date(tarih2Date),
              key: "selection",
              isShow: 0,
            },
          ])
        }
        className="flex items-center justify-center xsm:py-5 py-3 px-6 bg-[#00C08A] rounded-lg text-sm text-white w-full font-normal leading-normal"
      >
        Ön Rezervasyon Talebi
      </button>
    </div>
  );
};

export default OpportunityDateCard;
